const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A0A14] border-t border-white/5">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-black tracking-tighter">
                <span className="text-amber-400">69</span>
                <span className="text-white">视频</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              汇聚丝瓜视频、蓝莓视频、糖心视频、黑桃视频等特色视频网站，提供丰富视频资源免费在线观看，高清电影电视剧全集不缓冲播放。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">特色视频网站</h4>
            <ul className="space-y-2">
              <li><Link to="/category/sigua-video" className="text-gray-400 hover:text-amber-400 text-sm transition-colors">丝瓜视频</Link></li>
              <li><Link to="/category/blueberry-video" className="text-gray-400 hover:text-amber-400 text-sm transition-colors">蓝莓视频</Link></li>
              <li><Link to="/category/tangxin-video" className="text-gray-400 hover:text-amber-400 text-sm transition-colors">糖心视频</Link></li>
              <li><Link to="/category/heitao-video" className="text-gray-400 hover:text-amber-400 text-sm transition-colors">黑桃视频</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">更多平台</h4>
            <ul className="space-y-2">
              <li><Link to="/category/yaojing-video" className="text-gray-400 hover:text-amber-400 text-sm transition-colors">妖精视频</Link></li>
              <li><Link to="/category/taohua-video" className="text-gray-400 hover:text-amber-400 text-sm transition-colors">桃花视频</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-gray-400 hover:text-amber-400 text-sm transition-colors">品牌介绍</Link></li>
              <li><a href="#" className="text-gray-400 hover:text-amber-400 text-sm transition-colors">联系我们</a></li>
              <li><a href="#" className="text-gray-400 hover:text-amber-400 text-sm transition-colors">用户协议</a></li>
              <li><a href="#" className="text-gray-400 hover:text-amber-400 text-sm transition-colors">隐私政策</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs">
            &copy; {currentYear} 69视频 版权所有 | 69视频汇聚丝瓜视频、蓝莓视频、糖心视频、黑桃视频等特色视频网站
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/5 text-gray-400 hover:text-white hover:bg-white/10 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/5 text-gray-400 hover:text-white hover:bg-white/10 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/5 text-gray-400 hover:text-white hover:bg-white/10 transition-colors cursor-pointer" aria-label="B站">
              <i className="ri-bilibili-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;